/**
 * Cart Customer Gets Feature - Simplified
 * Shows recommended products based on cart contents
 */

theme.CartCustomerGets = (function () {
  'use strict';

  var selectors = {
    customerGetsSection: '[data-customer-gets-section]',
    customerGetsContainer: '[data-customer-gets]',
    variantSelect: 'select[name="cart__customer-gets-variants"]',
    productItem: '.cart__customer-gets-item',
    cartDrawer: '#CartDrawer',
    cartForm: '#CartDrawerForm',
  };

  var classes = {
    disabled: 'cart__customer-gets-disabled',
    loading: 'cart__customer-gets-loading',
  };

  var isProcessing = false;

  function showLoadingState() {
    const section = document.querySelector(selectors.customerGetsSection);
    if (section) {
      section.classList.add(classes.loading);
    }
  }

  function disableCustomerGetsSection() {
    const section = document.querySelector(selectors.customerGetsSection);
    if (section) {
      section.classList.add(classes.disabled);
    }
  }

  function enableCustomerGetsSection() {
    const section = document.querySelector(selectors.customerGetsSection);
    if (section) {
      section.classList.remove(classes.disabled);
    }
  }

  function handleVariantSelection(evt) {
    const select = evt.target;
    const variantId = select.value;
    const productItem = select.closest(selectors.productItem);

    if (!variantId || select.disabled) {
      return;
    }

    if (isProcessing) {
      select.selectedIndex = 0;
      return;
    }

    isProcessing = true;

    // Store original text if not already stored
    if (!select.getAttribute('data-original-text')) {
      select.setAttribute('data-original-text', select.options[0].textContent);
    }

    // Disable the entire section
    showLoadingState();
    disableCustomerGetsSection();

    // Show loading state
    const originalText = select.options[0].textContent;
    select.options[0].textContent = 'Adding...';

    // Add to cart using Shopify's API
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: JSON.stringify({
        id: variantId,
        quantity: 1,
      }),
      credentials: 'same-origin',
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
      })
      .then(function (item) {
        // Success - trigger cart update
        document.dispatchEvent(
          new CustomEvent('ajaxProduct:added', {
            detail: { product: item, variant: variantId },
          })
        );

        // Update customer gets section after a delay
        setTimeout(() => {
          updateCustomerGetsSection();
        }, 500);
      })
      .catch(function (error) {
        console.error('Error adding product to cart:', error);

        // Reset select state on error
        select.options[0].textContent = originalText;
        select.selectedIndex = 0;

        // Re-enable section on error
        enableCustomerGetsSection();
      })
      .finally(function () {
        isProcessing = false;
      });
  }

  function initializeSelects(container) {
    if (!container) return;

    const selects = container.querySelectorAll(selectors.variantSelect);

    selects.forEach(function (select) {
      if (select.options[0] && !select.getAttribute('data-original-text')) {
        select.setAttribute('data-original-text', select.options[0].textContent);
      }

      select.removeEventListener('change', handleVariantSelection);
      select.addEventListener('change', handleVariantSelection);
    });
  }

  function updateCustomerGetsSection() {
    const container =
      document.querySelector(selectors.customerGetsContainer) ||
      document.querySelector('.cart-drawer') ||
      document.querySelector('#CartDrawer');

    if (!container) {
      console.log('No container found for customer gets section');
      return;
    }

    const existingSection = container.querySelector(selectors.customerGetsSection);

    // Disable section during update
    if (existingSection) {
      disableCustomerGetsSection();
    }

    // Use Shopify's Section Rendering API to get fresh content
    // Fetch from /cart path to ensure cart context is available (product pages may cache without cart)
    fetch(`/cart?section_id=cart-customer-gets`)
      .then((response) => response.text())
      .then((html) => {
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = html;

        const newCustomerGetsSection = tempDiv.querySelector(selectors.customerGetsSection);

        if (newCustomerGetsSection) {
          if (existingSection) {
            existingSection.replaceWith(newCustomerGetsSection);
          } else {
            container.appendChild(newCustomerGetsSection);
          }
          initializeSelects(newCustomerGetsSection);
        } else if (existingSection) {
          existingSection.remove();
        }
      })
      .catch((error) => {
        console.error('Error updating customer gets section:', error);
        // Re-enable section on error
        enableCustomerGetsSection();
      });
  }

  function updateCartDrawer() {
    try {
      if (window.refreshCart && typeof window.refreshCart === 'function') {
        window.refreshCart();
      } else if (theme.cart && theme.cart.getCart) {
        theme.cart
          .getCart()
          .then((cart) => {
            document.dispatchEvent(
              new CustomEvent('cart:refresh', {
                bubbles: true,
                detail: cart,
              })
            );
          })
          .catch((error) => console.error('Error fetching cart:', error));
      }
    } catch (error) {
      console.error('Error fetching cart:', error);
    }
  }

  // Event listeners
  document.addEventListener('ajaxProduct:added', function (evt) {
    setTimeout(() => {
      updateCartDrawer();
      updateCustomerGetsSection();
    }, 100);
  });

  document.addEventListener('cart:updated', function () {
    setTimeout(() => {
      updateCartDrawer();
      updateCustomerGetsSection();
    }, 100);
  });

  function init() {
    document.querySelectorAll(selectors.customerGetsSection).forEach(initializeSelects);

    document.addEventListener('submit', function (evt) {
      const form = evt.target;
      if (form.action && form.action.includes('/cart/add')) {
        setTimeout(() => {
          updateCartDrawer();
          updateCustomerGetsSection();
        }, 500);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  return {
    init: init,
    updateCartDrawer: updateCartDrawer,
    updateCustomerGetsSection: updateCustomerGetsSection,
    disableCustomerGetsSection: disableCustomerGetsSection,
    enableCustomerGetsSection: enableCustomerGetsSection,
  };
})();
